import { defaultFetch } from './baseApi';
import { ProjectType } from './projectApi';

export type AggregateApi = {
	id: number;
	description: string;
	name: string;
	notes: string;
	isActive: boolean;
	isPublic: boolean;
	canUseTrackRecord: boolean;
	owner: string | null;
	ownerId: number | null;
	projectsCount: number;
	projectsSumTotalAmount: number;
	projects: ProjectType[];
};

export const getProjectAggregate = async (aggregateId: string) => {
	return defaultFetch<AggregateApi>(`/v0/projectaggregates/${aggregateId}`);
};

export type BusinessIntelligenceData = {
	token: string;
	embedUrl: string;
	expiresAt: string;
};

export const getProjectAggregateBusinessIntelligenceData = async (aggregateId: string) => {
	return defaultFetch<BusinessIntelligenceData>(`/v0/business-intelligence/projectaggregates/${aggregateId}`);
};
